<template>
  <div class="login-as-tool new-globals">
    <md-card>
      <md-progress-bar v-if="loading || loggingIn" md-mode="indeterminate" />
      <md-card-header>
        <div class="md-title">View As User</div>
        <div class="md-subhead">Select a text field to modify its content</div>
      </md-card-header>

      <md-card-content>
        <span v-if="error" class="error">{{ error.message || error.error || error }}</span>
        <md-autocomplete
          ref="orgsAutocomplete"
          placeholder="Organization"
          :md-options="orgs"
          :disabled="loading"
          value
          :md-open-on-focus="true"
          :md-fuzzy-search="false"
          @md-selected="updateSelectedOrg"
        >
          <label>Organization</label>
          <template slot="md-autocomplete-item" slot-scope="{ item }">{{ item.name }}</template>
        </md-autocomplete>
        <md-autocomplete
          ref="orgMembersAutocomplete"
          placeholder="User"
          :md-options="orgMembersWithLabel"
          value
          :disabled="loading"
          :md-open-on-focus="true"
          :md-fuzzy-search="false"
          @md-selected="updateSelectedUser"
        >
          <label>User</label>
          <template slot="md-autocomplete-item" slot-scope="{ item }">
            {{ item.label }}
          </template>
        </md-autocomplete>
      </md-card-content>
      <md-card-actions>
        <md-button
          :disabled="!state.selectedUser || loading || loggingIn"
          class="md-raised md-secondary"
          @click="loginAsSelectedUser"
        >
          Login As
        </md-button>
      </md-card-actions>
    </md-card>
  </div>
</template>

<script>
export default {
  name: 'login-as-tool',
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    loggingIn: {
      type: Boolean,
      default: false
    },
    error: {
      type: Object,
      default: null
    },
    orgs: {
      type: Array,
      default: () => []
    },
    orgMembers: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      state: {
        selectedOrg: null,
        selectedUser: null,
      }
    };
  },
  computed: {
    orgMembersWithLabel() {
      return this.orgMembers.map(user => ({
        ...user,
        label: this.userLabel(user),
      }))
    }
  },
  methods: {
    userLabel(user) {
      if (user.given_name || user.family_name) {
        return `${user.given_name || ''} ${user.family_name || ''} - ${user.email}`.trim();
      }
      return user.email;
    },
    updateSelectedOrg(org) {
      this.state.selectedOrg = org;
      this.$emit('fetchOrgMembers', this.state.selectedOrg);
      this.$nextTick(() => {
        // Force close the autocomplete, vue material bug
        if (this.$refs.orgsAutocomplete) {
          this.$refs.orgsAutocomplete.showMenu = false;
        }
      });
    },
    updateSelectedUser(user) {
      this.state.selectedUser = user;
      this.$nextTick(() => {
        // Force close the autocomplete, vue material bug
        if (this.$refs.orgMembersAutocomplete) {
          this.$refs.orgMembersAutocomplete.showMenu = false;
        }
      });
    },
    loginAsSelectedUser() {
      const { selectedOrg, selectedUser } = this.state;
      if (!selectedOrg || !selectedUser) {
        return;
      }
      this.$emit('loginAs', selectedOrg, selectedUser);
    }
  }
};
</script>

<style scoped>
.error {
  color: red;
}
</style>